import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'insurance-policy-settings',
	templateUrl: './insurance-policy-settings.component.html',
	imports: [
		CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemErrorComponent, FormsModule
	]
})
export default class InsurancePolicySettingsView implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.initialized = false;
		this.routingService.validateAccess('policySettings').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.stepIndex = 0;
		this.vm.stepChain = [];
		
		this.vm.getCurrentStep = this.getCurrentStep;
		this.vm.isStepPassed = this.isStepPassed;
		this.vm.isFirstStep = this.isFirstStep;
		this.vm.isLastStep = this.isLastStep;
		this.vm.previousStep = this.previousStep;
		this.vm.submitStep = this.submitStep;
		this.vm.goToInsuranceList = this.goToInsuranceList;
		
		this.vm.isInitialized = true;
		this.vm.isProcessing = false;
		
		var params: any = this.angularRoutingHelperService.getQueryParams();
		if (!params) {
			params = {};
		}
		this.vm.mode = params['mode'];
		this.vm.policyUserId = params['policyUserId'];
		this.vm.minDate = new Date(1885, 0, 1);
		this.vm.user = this.session.getSession().user;
		this.vm.birthDate = this.getBirthDateFromPersonalCode(this.vm.user.personalCode);
		this.vm.countries = this.config.getCountries();
		this.vm.isPositiveAnswerSelected = this.isPositiveAnswerSelected;
		this.vm.isUserSettingsRequired = params['userSettingsRequired'] === 'yes';
		this.vm.isBankAccountRequired = params['bankAccountRequired'] === 'yes';
		this.vm.isHealthQuestionnaireRequired = params['questionnaireRequired'] === 'yes';
		this.vm.healthQuestionnaireId = !!(params['questionnaireId']) ? parseInt(params['questionnaireId']) : 0;
		
		if (this.vm.isUserSettingsRequired) this.vm.stepChain.push(1);
		if (this.vm.isBankAccountRequired) this.vm.stepChain.push(2);
		if (this.vm.isHealthQuestionnaireRequired) this.vm.stepChain.push(3);
		this.vm.stepChain.push(4);
		
		this.vm.userDetails = {
			country: undefined,
			birthDate: this.vm.birthDate ? moment(this.vm.birthDate).format() : undefined
		};
		
		this.vm.paymentDetails = {
			accountHolderName: this.vm.user.firstname + ' ' + this.vm.user.lastname,
			accountNumber: ''
		};
		
		this.vm.questionnaire = {
			questions: [],
			answers: {}
		};
		
		this.updateDefaultCountry('EE');
		this.loadUserSettings();
		if (this.vm.isBankAccountRequired) this.loadLastPaymentMethod();
		if (this.vm.isHealthQuestionnaireRequired) this.loadQuestionnaire(this.vm.healthQuestionnaireId);
		this.vm.initialized = true;
	}
	
	getDate(personalCode) {
		if (personalCode.charAt(5) == '0') {
			return parseInt(personalCode.substring(6, 7));
		} else {
			return parseInt(personalCode.substring(5, 7));
		}
	}
	
	getMonth(personalCode) {
		if (personalCode.charAt(3) == '0') {
			return parseInt(personalCode.substring(4, 5));
		} else {
			return parseInt(personalCode.substring(3, 5));
		}
	}
	
	getYear(centuryIndicator, yearEnding) {
		if (centuryIndicator == 1 || centuryIndicator == 2) {
			return 2000 + yearEnding;
		} else if (centuryIndicator == 3 || centuryIndicator == 4) {
			return 1900 + yearEnding;
		} else if (centuryIndicator == 5 || centuryIndicator == 6) {
			return 2000 + yearEnding;
		} else if (centuryIndicator == 7 || centuryIndicator == 8) {
			return 2100 + yearEnding;
		} else {
			return 1900 + yearEnding;
		}
	}
	
	getBirthDateFromPersonalCode(personalCode) {
		if (personalCode == undefined || personalCode == null || personalCode.length != 11) {
			return undefined;
		}
		var centuryIndicator: any = parseInt(personalCode.substring(0, 1));
		var yearEnding: any = parseInt(personalCode.substring(1, 3));
		var year: any = this.getYear(centuryIndicator, yearEnding);
		var month: any = this.getMonth(personalCode) - 1;
		var date: any = this.getDate(personalCode);
		return new Date(year, month, date);
	}
	
	updateDefaultCountry(countryCode) {
		this.vm.userDetails.country = this.getCountryCode(countryCode);
	}
	
	getCountryCode(countryCode) {
		var theObj: any = this.config.getCountries() || [];
		var foundCountry: any = theObj.find((country) => {return country.code === countryCode});
		if (foundCountry) {
			return this.angularHelperService.copy(foundCountry['code']);
		}
		return undefined;
	}
	
	loadUserSettings() {
		this.vm.isProcessing = true;
		this.restService.getUserSettings({})
			.then((userSettings) => {
				this.vm.isProcessing = false;
				this.vm.userDetails.birthDate = this.vm.birthDate ? moment(this.vm.birthDate).format() : userSettings.birthDate;
				if (userSettings && userSettings['countryOfResidence'] && userSettings['countryOfResidence']['code']) {
					this.updateDefaultCountry(userSettings['countryOfResidence']['code']);
				}
			})
			.catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	loadLastPaymentMethod() {
		this.vm.isProcessing = true;
		this.restService.getLastPaymentMethod(this.vm.mode === 'edit' ? { policyUserId: this.vm.policyUserId } : {})
			.then((paymentMethod) => {
				this.vm.isProcessing = false;
				this.vm.paymentDetails.accountHolderName = paymentMethod.accountHolderName || this.vm.paymentDetails.accountHolderName;
				this.vm.paymentDetails.accountNumber = paymentMethod.accountNumber;
			})
			.catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	loadQuestionnaire(questionnaireId) {
		this.vm.isProcessing = true;
		this.restService.getUserPolicyQuestionnaire({ questionnaireId: questionnaireId, language: this.vm.user.deviceLanguage })
			.then((questionnaire) => {
				console.log(questionnaire)
				this.vm.isProcessing = false;
				this.vm.questionnaire.questions = questionnaire.questions;
			})
			.catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	isStepPassed(step) {
		return this.vm.stepChain.indexOf(step) < this.vm.stepIndex;
	}
	
	isFirstStep(step) {
		return this.vm.stepChain[0] === step;
	}
	
	isLastStep(step) {
		return this.vm.stepChain[this.vm.stepChain.length - 2] === step;
	}
	
	getPreviousStep() {
		if (this.vm.stepIndex === 0) return undefined;
		return this.vm.stepChain[this.vm.stepIndex - 1];
	}
	
	getNextStep() {
		if (this.vm.stepIndex >= (this.vm.stepChain.length - 1)) return undefined;
		return this.vm.stepChain[this.vm.stepIndex + 1];
	}
	
	getCurrentStep() {
		return this.vm.stepChain[this.vm.stepIndex];
	}
	
	previousStep() {
		if (this.vm.stepIndex > 0) this.vm.stepIndex--;
	}
	
	submitStep(mainForm: any) {
		var currentStep: any = this.getCurrentStep();
		if (currentStep === 1) {
			this.uploadUserDetails(mainForm);
		} else if (currentStep === 2) {
			this.uploadPaymentDetails(mainForm);
		} else if (currentStep === 3) {
			this.uploadHealthQuestionnaire(mainForm);
		}
	}
	
	uploadUserDetails(mainForm: any) {
		this.vm.userDetailsSubmitted = true;
		if (mainForm.invalid || this.vm.isProcessing || !this.vm.isInitialized) return;
		
		var payload: any = {
			policyUser: {id: this.vm.policyUserId},
			birthDate: this.vm.userDetails.birthDate ? moment(this.vm.userDetails.birthDate).toDate() : undefined,
			countryOfResidence: { code: this.vm.userDetails.country ? this.getCountryCode(this.vm.userDetails.country) : undefined }
		};
		this.vm.isProcessing = true;
		this.restService.saveUpdatePolicyUserSettings(payload)
			.then((response) => {
				this.vm.isProcessing = false;
				this.vm.stepIndex++;
			}).catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	uploadPaymentDetails(mainForm: any) {
		this.vm.paymentDetailsSubmitted = true;
		if (mainForm.invalid || this.vm.isProcessing || !this.vm.isInitialized) return;
		
		var payload: any = {
			policyUser: {id: this.vm.policyUserId},
			accountNumber: this.vm.paymentDetails.accountNumber,
			accountHolderName: this.vm.paymentDetails.accountHolderName
		};
		this.vm.isProcessing = true;
		this.restService.saveUpdatePolicyPaymentMethod(payload)
			.then((response) => {
				this.vm.isProcessing = false;
				this.vm.stepIndex++;
			}).catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	uploadHealthQuestionnaire(mainForm: any) {
		this.vm.questionnaireSubmitted = true;
		if (mainForm.invalid || this.vm.isProcessing || !this.vm.isInitialized) return;
		
		var answers: Array<any> = [];
		this.vm.questionnaire.questions.forEach((question) => {
			question.answers.forEach((answer) => {
				if ((question['answerType'] === 'YES_NO' || question['answerType'] === 'RADIO') 
					&& this.vm.questionnaire.answers[question.id] === answer.id) {
					answers.push(answer);
				} else if (question['answerType'] === 'CHECKBOX' 
					&& this.vm.questionnaire.answers[question.id + '-' + answer.id] === true) {
					answers.push(answer);
				} else if ((question['answerType'] === 'TEXT' || question['answerType'] === 'TEXTAREA') 
					&& this.vm.questionnaire.answers[question.id]) {
					answer.freeText = this.vm.questionnaire.answers[question.id];
					answers.push(answer);
				}
			})
		});
		
		this.vm.isProcessing = true;
		var pathParams = {
			policyUserId: this.vm.policyUserId,
			questionnaireId: this.vm.healthQuestionnaireId,
			language: this.vm.user.deviceLanguage
		};
		this.restService.saveUpdateUserPolicyQuestionnaire(pathParams, answers)
			.then((response) => {
				this.vm.isProcessing = false;
				this.vm.stepIndex++;
			})
			.catch((error) => {
				this.vm.isProcessing = false;
				console.error(error);
			});
	}
	
	isPositiveAnswerSelected(questionId) {
		var question: any = this.vm.questionnaire.questions.find((question) => {return question.id === questionId});
		var answerId: any = question && this.vm.questionnaire.answers[questionId] ? this.vm.questionnaire.answers[questionId] : undefined;
		
		if (answerId) {
			var answer: any = question.answers.find((answer) => {return answer.id === answerId});
			return answer.score === 1;
		}
		return false;
	}
	
	goToInsuranceList() {
		this.angularRoutingHelperService.setPath('/insurance/policies', false, false, {});
	}
	
}